<template>
  <div class="my-background">
    <div style="background-color: #fffffff4">
      <CSLayout view="hHh Lpr fFf">
        <Header />

        <PageContainer class="q-pa-md" />

        <Footer />
      </CSLayout>

      <ErrorDialog v-for="item in messages" :message="item" :key="item.title" />
      <InActiveNotification />
    </div>
  </div>
</template>

<script setup lang="ts">
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://vuejs.org/api/sfc-script-setup.html#script-setup

//import HelloWorld from "./components/HelloWorld.vue";
// import UserCreate from "@/views/User/UserCreate.vue";

import CSLayout from "@/components/CharitySystem/CSLayout.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";
import InActiveNotification from "@/components/InActiveNotification.vue";

import PageContainer from "@/components/PageContainer.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { useStore } from "@/store";
import { computed } from "vue";

const store = useStore();

const messages = computed(() => store.state.messages);

const backgroundImage = computed(() => {
  switch (import.meta.env.VITE_NODE_ENV) {
    //case "development":
    case "test":
      return "url(/images/TestImage.png)";
    case "preproduction":
      return "url(/images/PreProdImage.png)";
    default:
      return "none";
  }
});

document.documentElement.style.setProperty(
  "--haf-background-image",
  import.meta.env.VITE_NODE_ENV,
);
</script>

<style>
/**To remove the spinners next to number inputs*/
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>

<style scoped>
.my-background {
  background-image: v-bind(backgroundImage);
  background-repeat: repeat;
  background-size: 150px 100px;
}
</style>
